import {
  APPLICATION_STATUS_LABELS,
  DUE_LABELS,
  type ApplicationStatus,
  type DueTone,
} from "service/business";

const STATUS_COLOURS: Record<ApplicationStatus, { bg: string; text: string }> = {
  not_submitted: { bg: "#EEF0F4", text: "#4B5160" },
  invite_sent: { bg: "#EEF0F4", text: "#4B5160" },
  in_progress: { bg: "#EEF0F4", text: "#555B6E" },
  waiting: { bg: "#E1EBFC", text: "#165FE3" },
  sent_back: { bg: "#FFF1D6", text: "#8A5200" },
  approved: { bg: "#E1FFE2", text: "#14622A" },
  not_approved: { bg: "#FFE3E3", text: "#C62828" },
  closed: { bg: "#EEF0F4", text: "#555B6E" },
};

const DUE_COLOURS: Record<DueTone, { bg: string; text: string }> = {
  overdue: { bg: "#FFE3E3", text: "#C62828" },
  today: { bg: "#FFF1D6", text: "#8A5200" },
  within: { bg: "#E1FFE2", text: "#14622A" },
};

const base =
  "inline-block py-[3px] px-2 rounded-md text-sm leading-4 font-medium whitespace-nowrap";

export function StatusChip({ status }: Readonly<{ status: ApplicationStatus }>) {
  const c = STATUS_COLOURS[status];
  return (
    <span
      className={base}
      style={{ backgroundColor: c.bg, color: c.text }}
    >
      {APPLICATION_STATUS_LABELS[status]}
    </span>
  );
}

export function DueChip({ tone }: Readonly<{ tone: DueTone }>) {
  const c = DUE_COLOURS[tone];
  return (
    <span className={base} style={{ backgroundColor: c.bg, color: c.text }}>
      {DUE_LABELS[tone]}
    </span>
  );
}
